import React from "react";
import { css } from "@emotion/react";

interface Props {
  title: string;
  isRequired?: boolean;
}

export const SurveyTitle = ({ title, isRequired }: Props) => {
  return <h3 css={surveyTitleStyle}>{title} {isRequired && <span css={requiredMarkStyle}>※</span>}</h3>;
};

const surveyTitleStyle = css({
  fontWeight: "bold",
  textAlign: "center",
  marginBottom: '20px',
  lineHeight: '1.5',
});

const requiredMarkStyle = css({
  color: '#f2a40b',
  fontSize: 14,
  marginLeft: '8px',
})